export const fetchTopics = resp => {
  return {
    type: "FETCH_TOPICS",
    payload: resp
  };
};

/*export const fetchTopicComments = resp => {
  return {
    type: "FETCH_TOPIC_COMMENTS",
    payload: resp
  };
};*/



// WEBPACK FOOTER //
// ./src/actions/actions/topic.js